import { h, Component } from 'preact';
import {
  ISplashScreenContent,
  ISplashScreensCarouselProps, ISplashScreensCarouselState
} from '../sgwt-splash-screen.types';

const Modal = require('react-bootstrap/lib/Modal');

export default class SplashScreensCarousel extends Component<ISplashScreensCarouselProps, ISplashScreensCarouselState> {
  constructor(props: ISplashScreensCarouselProps) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState(): ISplashScreensCarouselState {
    return {
      currentSlide: 0,
      nextSlide: null,
      prepareLeaving: false,
      leaving: null,
      direction: null
    };
  }

  private startAnimation(direction: string, nextSlide: number) {
    this.setState({
      prepareLeaving: true,
      direction: direction,
      nextSlide: nextSlide
    });

    // Start the animation by putting 'next' or 'prev' CSS class on the new slide to show...
    setTimeout(() => {
      this.setState({
        leaving: direction === 'next' ? 'left' : 'right'
      });
    }, 100);

    // Now set the next slide as 'active'.
    setTimeout(() => {
      this.setState({
        direction: null,
        leaving: null,
        prepareLeaving: false,
        currentSlide: nextSlide,
        nextSlide: null
      });
    }, 600);
  }

  private nextScreen() {
    const nextSlide = (this.state.currentSlide + 1) % this.props.screens.length;
    this.startAnimation('next', nextSlide);
  }

  private previousScreen() {
    const nextSlide = this.state.currentSlide === 0 ? this.props.screens.length - 1 : this.state.currentSlide - 1;
    this.startAnimation('prev', nextSlide);
  }

  private getSlideClasses(index: number, mainClass: string): string[] {
    const classes = [mainClass];
    // Is it a slide that can be moved? Either the current one or the next one to display for animations.
    let slideToMove = false;

    if (index === this.state.currentSlide) {
      classes.push('active');
      slideToMove = true;
    }

    // For the next slide to show, set the `prev` or `next` class.
    if (this.state.direction && this.state.prepareLeaving && index === this.state.nextSlide) {
      classes.push(this.state.direction);
      slideToMove = true;
    }
    // Move the slide left or right.
    if (this.state.leaving && slideToMove) {
      classes.push(this.state.leaving);
    }
    return classes;
  }

  render(props: ISplashScreensCarouselProps, state: ISplashScreensCarouselState): JSX.Element {
    if (props.screens.length === 0) {
      return <div/>;
    }
    const screen = props.screens[state.currentSlide];

    let logo = null;
    if (screen.logo) {
      logo = <img class="sgwt-splash-screen-application-logo" src={screen.logo} alt={`${screen.application} logo`}/>;
    }

    const InnerHTMLHelper = ({html}: ISplashScreenContent) => h('div', {dangerouslySetInnerHTML: {__html: html}});

    // Define slides
    const slides = props.screens.map((screen, index) => {
      const classes = this.getSlideClasses(index, 'item');
      return (
        <div class={classes.join(' ')}>
          <InnerHTMLHelper html={screen.content}/>
        </div>
      );
    });

    // Define titles
    const titles = props.screens.map((screen, index) => {
      const classes = this.getSlideClasses(index, 'title');
      return (
        <div class={classes.join(' ')}>
          {screen.title}
        </div>
      );
    });

    const multi = props.screens.length > 1;

    // Controls for previous or next slide...
    const navigationControls = multi ?
      <div>
        <a
          class="btn btn-arrow btn-icon left carousel-control"
          role="button"
          data-slide="prev"
          onClick={() => this.previousScreen()}>
          <i class="fa fa-angle-left" aria-hidden="true"/>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="btn btn-arrow btn-icon right carousel-control"
          role="button"
          data-slide="next"
          onClick={() => this.nextScreen()}>
          <i class="fa fa-angle-right" aria-hidden="true"/>
          <span class="sr-only">Next</span>
        </a>
      </div> : <span/>;

    return (
      <div>
        <Modal.Header>
          <Modal.Title bsClass="sgwt-splash-screen-carousel-title">
            {titles}
            {logo}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body bsClass="sgwt-splash-screen-body">
          <div class="carousel slide" data-ride="carousel">
            <div class="sgwt-splash-screen carousel-inner" role="listbox">
              {slides}
            </div>
            {navigationControls}
          </div>
        </Modal.Body>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-splash-screen/components/SplashScreensCarousel.tsx